/**
 * Order-independent equality of two arrays by value (works for primitive element types).
 *
 * Compares as sets, not multisets: equal-length arrays with different duplicate counts — e.g.
 * `[1, 1, 2]` and `[1, 2, 2]` — compare equal. Intended for id collections that are unique by
 * construction.
 */
export function hasSameElements<T>(a: T[], b: T[]): boolean {
    if (a.length !== b.length) {
        return false;
    }

    const other = new Set(b);
    return a.every((item) => other.has(item));
}
